import React, { useEffect, useState } from "react"
import { OverlayTrigger, Popover } from "react-bootstrap"

import { isLTPM, injectIntl } from "../../../../components/shared_components_registration"
import { fillColors } from "./ActionLayer"
import { FeatureTriangle } from "./ActionLayer/FeatureTriangles"
import { withGraphState } from "../../../config/GraphConfigProvider"

const registration = {
  site_action_label: (intl) => "Site Actions", // Doesn't exist on LTPM currently. No translation needed.
  action_label: (intl) =>
    isLTPM
      ? `${intl.formatMessage({ id: "general.action" })} (${intl.formatMessage({
          id: "general.priority.normal",
        })})`
      : "Actions",
  critical_action_label: (intl) =>
    isLTPM
      ? `${intl.formatMessage({ id: "general.action" })} (${intl.formatMessage({
          id: "general.priority.critical",
        })})`
      : "Critical Actions",
  annotation_label: (intl) => "Annotations", // Doesn't exist on LTPM currently. No translation needed.
  action_filter_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.filter" }) : "Filter Actions"),
}

const ToggleActionLayers = ({
  download,
  height,
  intl,
  extraStyle = { position: "absolute" },
  show_site_actions, // From withGraphState
  show_actions, // From withGraphState
  show_critical_actions, // From withGraphState
  show_annotations, // From withGraphState
  updateActionLayerVisibility, // From withGraphState
  disabled = false,
}) => {
  const [showSiteActions, setShowSiteActions] = useState(true)
  useEffect(() => {
    setShowSiteActions(show_site_actions)
  }, [show_site_actions])

  const [showActions, setShowActions] = useState(true)
  useEffect(() => {
    setShowActions(show_actions)
  }, [show_actions])

  const [showCriticalActions, setShowCriticalActions] = useState(true)
  useEffect(() => {
    setShowCriticalActions(show_critical_actions)
  }, [show_critical_actions])

  const [showAnnotations, setShowAnnotations] = useState(true)
  useEffect(() => {
    setShowAnnotations(show_annotations)
  }, [show_annotations])

  return (
    <>
      {!download && (
        <OverlayTrigger
          trigger={"click"}
          placement={"right"}
          rootClose
          overlay={
            <Popover
              id="toggle_action_layers"
              onClick={(e) => {
                e.stopPropagation()
              }}
            >
              <Popover.Body>
                <div>
                  {!isLTPM && (
                    <ActionCheckbox
                      checked={showSiteActions}
                      setChecked={() => updateActionLayerVisibility("show_site_actions", !showSiteActions)}
                      colours={["site_action"]}
                      label={registration.site_action_label(intl)}
                    />
                  )}
                  <ActionCheckbox
                    checked={showActions}
                    setChecked={() => updateActionLayerVisibility("show_actions", !showActions)}
                    colours={["run_action"]}
                    label={registration.action_label(intl)}
                  />
                  <ActionCheckbox
                    checked={showCriticalActions}
                    setChecked={() =>
                      updateActionLayerVisibility("show_critical_actions", !showCriticalActions)
                    }
                    colours={["run_action_critical"]}
                    label={registration.critical_action_label(intl)}
                  />
                  {!isLTPM && (
                    <ActionCheckbox
                      checked={showAnnotations}
                      setChecked={() => updateActionLayerVisibility("show_annotations", !showAnnotations)}
                      colours={["not_tag_specific_ano", "tag_specific_ano"]}
                      label={registration.annotation_label(intl)}
                    />
                  )}
                </div>
              </Popover.Body>
            </Popover>
          }
        >
          <button
            className="btn btn-outline-primary btn-sm"
            type="button"
            style={{ ...extraStyle, top: `${height}px`, left: "5px", zIndex: "100" }}
            title={registration.action_filter_label(intl)}
            onClick={(ev) => ev.stopPropagation()}
            disabled={disabled}
          >
            <span
              className="fa fa-play"
              style={{
                color: "var(--lanzalake-green-primary)",
                rotate: "-90deg",
              }}
            />
          </button>
        </OverlayTrigger>
      )}
    </>
  )
}

export default withGraphState(injectIntl(ToggleActionLayers))

const ActionCheckbox = ({ checked, setChecked, label, colours }) => {
  return (
    <div style={{ display: "flex" }}>
      {colours.map((c, i) => (
        <div key={`${label}_${i}`} style={{ height: "15px", width: "15px" }}>
          <svg style={{ height: "15px", width: "15px" }}>
            <FeatureTriangle xpos={5} ft={null} getFillColor={() => fillColors[c]} />
          </svg>
        </div>
      ))}
      <label style={{ marginBottom: "0" }}>{label}:</label>
      &nbsp;
      <input type={"checkbox"} checked={checked} onChange={setChecked} />
    </div>
  )
}
